const inclusions = [
  {
    icon: 'ri-sofa-line',
    title: 'Fully Furnished Private Room',
    desc: 'Your private room comes fully furnished with a comfortable bed, quality mattress, wardrobe, desk, and chair. Everything you need from day one — just bring your personal belongings.',
    tag: 'Included',
  },
  {
    icon: 'ri-flashlight-line',
    title: 'Electricity',
    desc: 'All electricity costs are included in your weekly rate. Lights, appliances, heating, and cooling — covered, with no usage limits or bill anxiety.',
    tag: 'Included',
  },
  {
    icon: 'ri-water-flash-line',
    title: 'Water',
    desc: 'Your water usage is fully covered. Take showers, use the kitchen, do laundry — all without worrying about water bills.',
    tag: 'Included',
  },
  {
    icon: 'ri-fire-line',
    title: 'Gas',
    desc: 'Gas for cooking and hot water is included in your all-inclusive weekly rent. No separate gas accounts to set up or bills to pay.',
    tag: 'Included',
  },
  {
    icon: 'ri-wifi-fill',
    title: 'Unlimited Wi-Fi',
    desc: 'Fast, reliable, unlimited internet access throughout the entire property — perfect for remote work, streaming, study, or staying connected.',
    tag: 'Included',
  },
  {
    icon: 'ri-sparkling-2-line',
    title: 'Fortnightly Professional Cleaning',
    desc: 'Our professional cleaning team visits every fortnight to thoroughly clean all common areas — kitchen, bathrooms, hallways, and shared living spaces.',
    tag: 'Included',
  },
  {
    icon: 'ri-plant-line',
    title: 'Gardening & Outdoor Maintenance',
    desc: 'Regular professional garden maintenance keeps outdoor areas tidy, neat, and well-presented. Lawn mowing, hedge trimming, and general upkeep handled for you.',
    tag: 'Included',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: 'Responsive Property Management',
    desc: 'Our dedicated property management team is available to handle maintenance requests, answer questions, and resolve any issues quickly and professionally.',
    tag: 'Included',
  },
];

export default function ServicesDetail() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="flex items-center justify-center gap-3 mb-4">
            <div className="w-8 h-0.5 bg-gold-500" />
            <span className="text-gold-500 text-sm font-medium tracking-widest uppercase">Everything Included</span>
            <div className="w-8 h-0.5 bg-gold-500" />
          </div>
          <h2 className="font-heading text-4xl lg:text-5xl font-bold text-navy-800 leading-tight mb-5">
            One Rate. Zero Surprises.
          </h2>
          <p className="text-navy-700/65 text-base leading-relaxed">
            Our all-inclusive model is designed to eliminate the hassle and financial stress of managing multiple bills and service providers. Pay one simple weekly rate and enjoy a fully supported, comfortable home.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
          {inclusions.map((item) => (
            <div
              key={item.title}
              className="relative bg-white rounded-lg border border-navy-100 p-6 hover:border-gold-300 hover:-translate-y-1 transition-all duration-200"
            >
              <div className="absolute top-4 right-4 bg-emerald-50 text-emerald-600 text-xs font-semibold px-2.5 py-1 rounded-full whitespace-nowrap">
                {item.tag}
              </div>
              <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-navy-800 text-gold-400 mb-4">
                <i className={`${item.icon} text-lg`} />
              </div>
              <h3 className="font-semibold text-navy-800 text-base mb-2 pr-12 leading-snug">{item.title}</h3>
              <p className="text-navy-700/60 text-sm leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
